import { BASE_URL } from '../../config'
import publicIp from 'public-ip';
import { REQ_TNC, REQ_TNC_DONE,  SET_TNC, SET_ERROR_STATE } from '../../utils/constants/actionTypes';
import {GCheckTnC, GDetailTnC, PCheckTnC} from '../../config/api'

export default (ClientID, cb) => async dispatch => {
    dispatch({ type : REQ_TNC });
    let returnValue = false;

    try{
        let res = await fetch(`${BASE_URL}${GCheckTnC}`, {
                method : 'GET',
                credentials: 'include',
                headers : { 'X-Client-ID' : ClientID }
            })
        
        let hasil = await res.json();
        
        
        if( res.status !== 200 ){
            dispatch({ type : REQ_TNC_DONE })
			dispatch({ type : SET_ERROR_STATE, payload : hasil.status.message });
        }else{
            const {termsAndConditions} = hasil.result;
            if(termsAndConditions.length <= 0){
                dispatch({type : SET_TNC, payload : null})
            }else{
                let resDetail = await fetch(`${BASE_URL}${GDetailTnC(termsAndConditions[0].tncCode)}`, {
                    method : 'GET',
                    credentials: 'include',
                    headers : { 'X-Client-ID' : ClientID }
                }) 
                let detail = await resDetail.json();

                if(resDetail.status !== 200) {
                    dispatch({type : SET_TNC, payload : null});
                    dispatch({ type : SET_ERROR_STATE, payload : detail.status.message });
                }else{
                    returnValue = true;
                    dispatch({type : SET_TNC, payload : detail.result.termsAndCondition});
                }
            }
        }
    } catch(err){
		dispatch({ type : REQ_TNC_DONE })
		dispatch({ type : SET_ERROR_STATE, payload : err.message});
    }

    cb(returnValue);
} 


export const PostTermAndCondition = (ClientID, tncCode, data, cb) => async dispatch => {
    try{
        const res = await fetch(`${BASE_URL}${PCheckTnC(tncCode)}`, {
            method : 'POST',
            credentials: 'include',
            headers : { 
                'X-Client-ID' : ClientID,
                'Content-Type' : "application/json"
            },
            body: JSON.stringify({
                termsAndConditions : {
                    ipAddress : await publicIp.v4(),
                    items : data
                } 
            })
        })
        const hasil = await res.json();
        if(res.status !== 200) {
            dispatch({ type : SET_ERROR_STATE, payload : hasil.status.message });
            console.log('Error Post Term and Condition', hasil.status.message);
            cb(false);
        }else{
            cb(true);
        }
    } catch(err){
        dispatch({ type : SET_ERROR_STATE, payload : err.message });
        console.log('Error Post Term and Condition', err.message);
        cb(false);
    }
}
